/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetLivestockAttentionAnimalCountsQueryResponse, GetLivestockAttentionAnimalCountsPathParams, GetLivestockAttentionAnimalCountsQueryParams, GetLivestockAttentionAnimalCounts400, GetLivestockAttentionAnimalCounts401, GetLivestockAttentionAnimalCounts403, GetLivestockAttentionAnimalCounts404, GetLivestockAttentionAnimalCounts409, GetLivestockAttentionAnimalCounts500 } from "../../types/livestockController/GetLivestockAttentionAnimalCounts.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getLivestockAttentionAnimalCounts } from "../../client/livestockController/getLivestockAttentionAnimalCounts.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getLivestockAttentionAnimalCountsQueryKey = (organizationId: GetLivestockAttentionAnimalCountsPathParams["organizationId"] | undefined, params: GetLivestockAttentionAnimalCountsQueryParams) => [{ url: '/api/organizations/:organizationId/livestock-attention/animal-counts', params: {organizationId:organizationId} }, ...(params ? [params] : [])] as const

export type GetLivestockAttentionAnimalCountsQueryKey = ReturnType<typeof getLivestockAttentionAnimalCountsQueryKey>

export function getLivestockAttentionAnimalCountsQueryOptions(organizationId: GetLivestockAttentionAnimalCountsPathParams["organizationId"] | undefined, params: GetLivestockAttentionAnimalCountsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getLivestockAttentionAnimalCountsQueryKey(organizationId, params)
        return queryOptions<GetLivestockAttentionAnimalCountsQueryResponse, ResponseErrorConfig<GetLivestockAttentionAnimalCounts400 | GetLivestockAttentionAnimalCounts401 | GetLivestockAttentionAnimalCounts403 | GetLivestockAttentionAnimalCounts404 | GetLivestockAttentionAnimalCounts409 | GetLivestockAttentionAnimalCounts500>, GetLivestockAttentionAnimalCountsQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getLivestockAttentionAnimalCounts(organizationId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Per-animal attention totals for list/card badges (exact per page)
 * {@link /api/organizations/:organizationId/livestock-attention/animal-counts}
 */
export function useGetLivestockAttentionAnimalCounts<TData = GetLivestockAttentionAnimalCountsQueryResponse, TQueryData = GetLivestockAttentionAnimalCountsQueryResponse, TQueryKey extends QueryKey = GetLivestockAttentionAnimalCountsQueryKey>(organizationId: GetLivestockAttentionAnimalCountsPathParams["organizationId"] | undefined, params: GetLivestockAttentionAnimalCountsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetLivestockAttentionAnimalCountsQueryResponse, ResponseErrorConfig<GetLivestockAttentionAnimalCounts400 | GetLivestockAttentionAnimalCounts401 | GetLivestockAttentionAnimalCounts403 | GetLivestockAttentionAnimalCounts404 | GetLivestockAttentionAnimalCounts409 | GetLivestockAttentionAnimalCounts500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getLivestockAttentionAnimalCountsQueryKey(organizationId, params)
         

         const query = useQuery({
          ...getLivestockAttentionAnimalCountsQueryOptions(organizationId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetLivestockAttentionAnimalCounts400 | GetLivestockAttentionAnimalCounts401 | GetLivestockAttentionAnimalCounts403 | GetLivestockAttentionAnimalCounts404 | GetLivestockAttentionAnimalCounts409 | GetLivestockAttentionAnimalCounts500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}